import { TransportProvider } from "@connectrpc/connect-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import queryClient from "./_queryClient";
import Env from "./config";
import { router } from "./router";

const finalTransport = createConnectTransport({
  baseUrl: Env.grpcUrl,
  // @ts-expect-error
  fetch: (input, init) => fetch(input, { ...init, credentials: "include" }),
});

export function App() {
  return (
    <TransportProvider transport={finalTransport}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{}} />
      </QueryClientProvider>
    </TransportProvider>
  );
}
